import type { MailboxInfo } from 'owa-client-types';
import { getAccountScopeUserSettings } from '../selectors/getAccountScopeUserSettings';

export default function getArchiveFolderId(mailboxInfo: MailboxInfo): string | undefined {
    return getAccountScopeUserSettings(mailboxInfo)?.UserOptions?.ArchiveFolderId;
}
